import React from 'react';
import Main from './components/Main';
import 'antd/dist/antd.css';

function App() {
  return (
    <div>
      <Main />
    </div>
  );
}

export default App;
